import { ServiceProviderIdentifierType } from '@amzn/coral_com-amazon-carrierlogisticswebserver-model';

export const MONS_DIRECTOR_ID_QUERY_PARAM = 'mons_sel_dir_paid';
export const MONS_RETURN_TO_URL_KEY = 'returnTo';

export const REQUEST_PERMISSIONS_PAGE = '/request/permissions';

export const SERVICE_PROVIDER_MAPPING = {
  all: 'service_provider_options.all',
  [ServiceProviderIdentifierType.LOGISTICS_PARTY_ID]:
    'service_provider_options.lp',
  [ServiceProviderIdentifierType.DSP_COMPANY_ID]:
    'service_provider_options.dsp',
};

export const SERVICE_PROVIDER_OPTIONS = Object.keys(SERVICE_PROVIDER_MAPPING);

export const SERVICE_PROVIDER_TAGS = {
  [ServiceProviderIdentifierType.DSP_COMPANY_ID]: {
    theme: 'warning',
    id: 'DSP',
    tooltip: 'service_provider_options.dsp',
  },
};
